export enum RolesEnum {
  SUPER_ADMIN = 'SuperAdmin',
  ADMINISTRATION = 'Administration',
  AUTHOR = 'Author',
  REVIEWER = 'Reviewer',
}
